import useCheckIn from "../../../../data/useCheckIn";

// Legacy mode: fetches the check-in items per row. Kept for callers that only have a checkInId.
function FetchedCheckInStatus({ checkInId }: { checkInId?: string | null }) {
  const { checkInItems, checkInSteps } = useCheckIn(undefined, checkInId ?? undefined);
  const totalSteps = checkInSteps.data?.data?.length ?? 0;
  const activeStepCount = Math.max(totalSteps, 0);

  if (!checkInId) {
    return <span>0/{activeStepCount}</span>;
  }

  if (checkInItems.isLoading) {
    return <span>.../{activeStepCount}</span>;
  }

  const completedStepCount = (checkInItems.data?.data ?? []).filter((item) => !!item.completed).length;
  return <span>{completedStepCount}/{activeStepCount}</span>;
}

export default function LeadCheckInStatusCell({
  checkInId,
  completed,
  total,
}: {
  checkInId?: string | null;
  completed?: number;
  total?: number;
}) {
  // Preferred mode: counts supplied inline by the row (no per-row network call).
  if (completed !== undefined && total !== undefined) {
    return <span>{completed}/{total}</span>;
  }

  return <FetchedCheckInStatus checkInId={checkInId} />;
}
